// extracted by mini-css-extract-plugin
export default {"flexContainer":"Step3_flexContainer__1HpaD","PreviewCard":"Step3_PreviewCard__B2+y4","list":"Step3_list__YAdJo","Dragable":"Step3_Dragable__0PqGz"};